import { configureStore, combineReducers, AnyAction } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import appointmentsReducer from './slices/appointmentsSlice';
import servicesReducer from './slices/servicesSlice';
import staffReducer from './slices/staffSlice';
import resourcesReducer from './slices/resourcesSlice';
import settingsReducer from './slices/settingsSlice';
import uiReducer from './slices/uiSlice';

const combinedReducer = combineReducers({
  auth: authReducer, appointments: appointmentsReducer, services: servicesReducer,
  staff: staffReducer, resources: resourcesReducer, settings: settingsReducer, ui: uiReducer,
});
const rootReducer = (state: ReturnType<typeof combinedReducer> | undefined, action: AnyAction) =>
  combinedReducer(['auth/logout', 'auth/login/fulfilled', 'auth/register/fulfilled'].includes(action.type) ? undefined : state, action);

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
